import { TermsOfUseForManufacturerServicesSubPage } from '../TermsOfUseForManufacturerServicesSubPage';

export const ServiceEbikePicturesPage = () => (
  <TermsOfUseForManufacturerServicesSubPage page="portal.termsOfUse.manufacturerServices.ebikePictures" />
);
